import { useSelector } from 'src/store/react';
import { selectTimezone } from 'src/store/selectors';

export const useTimezone = () => useSelector(selectTimezone);
